import { ApiFail } from './ApiFail';

export class ResponseStatusInvalidFail extends ApiFail {}
